@if (layerService.showLegend()) {
  <app-small-dialog-container
    [title]="'Title.SubTitle.Legend' | transloco"
    (closeDialogClicked)="hideLegend()"
    [position]="legendPosition()"
  >
    <div class="flex flex-col">
      <div class="flex flex-row justify-between items-center mb-4">
        <div>
          <mat-icon [svgIcon]="'icn-settings'" class="!h-[12px] !w-[12px] mr-2" />
          <span>
            {{ "Module.Layer.ShowDistrict" | transloco }}
          </span>
        </div>
        <mat-slide-toggle [ngModel]="layerService.showDistrict()" (ngModelChange)="ActivateBorder()" hideIcon="true" />
      </div>
      @for (legendItem of legends() | keyvalue; track legendItem) {
        <div class="mb-2 last:mb-0">
          <app-info-expansion-panel [title]="legendItem.value.displayName" class="legend-panel">
            @if (legendItem.value.Unit) {
              <div class="flex justify-between items-center mb-2">
                <span class="text-sm font-semibold">{{ legendItem.value.Unit }}</span>
              </div>
            }
            @if (!legendItem.value.ColorRamp) {
              @for (item of legendItem.value.LayerLegend; track item) {
                <div class="flex items-center space-x-2 mb-1">
                  @if (item.IconUrl !== null) {
                    <img
                      class="w-5 h-5"
                      alt="Legend-Icon"
                      ngSrc="{{ item.IconUrl }}"
                      width="5"
                      height="5"
                      [style.background-color]="item.Color"
                    />
                  }
                  <div class="w-5 h-5" [style.background-color]="item.Color"></div>
                  <div>{{ item.DisplayText }}</div>
                </div>
              }
            }
            @if (legendItem.value.ColorRamp) {
              <app-color-ramp
                [colors]="getColorRamp(legendItem.value.LayerLegend)"
                [minValue]="legendItem.value.LayerLegend[0].DisplayText || legendItem.value.LayerLegend[0].Value"
                [maxValue]="
                  legendItem.value.LayerLegend[legendItem.value.LayerLegend.length - 1].DisplayText ||
                  legendItem.value.LayerLegend[legendItem.value.LayerLegend.length - 1].Value
                "
              />
            }
          </app-info-expansion-panel>
        </div>
      }
    </div>
  </app-small-dialog-container>
}
